import campaignNamesForCustomer from 'main/campaignNamesAndDesc'

export function getCampaignTitle(campaign) {
  if (campaign.type === 'consentRequest') {
    return 'Default text'
  }

  if (campaign.type === 'nonOTAVariant') {
    return 'For direct guests'
  }

  if (campaign.type === 'OTAVariant') {
    return 'For OTA guests'
  }

  if (campaign.category === 'MissingDetailReminder1') {
    return 'Next day reminder'
  }

  if (campaign.category === 'MissingDetailReminder2') {
    return 'Next week reminder'
  }

  if (campaign.category === 'OptInRequest') {
    return 'Widget consent request'
  }

  if (campaign.category === 'OptedIn') {
    return 'Widget welcome'
  }

  if (campaign.category === 'ReviewReminder1') {
    return 'Reminder (one day after request)'
  }

  if (campaign.category === 'ReviewReminder2') {
    return '2nd reminder (two days after request)'
  }

  return campaignNamesForCustomer[campaign.category] || campaign.category
}
